import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import MiniPlayer from './MiniPlayer';

/** Wraps PUBLIC marketing pages (landing variants, /for-*, /memberships, /tour, /changelog) with
 * the same Navbar + Footer as authed pages — so navigation is everywhere.
 * Different from <AppLayout /> which redirects unauthenticated users.
 */
export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--theme-bg)', color: 'var(--theme-fg)' }}>
      <Navbar />
      <main className="flex-1 px-4 md:px-8 py-6 max-w-screen-2xl w-full mx-auto pb-24" data-testid="public-layout-main">
        <Outlet />
      </main>
      <Footer />
      <MiniPlayer />
    </div>
  );
}
